var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"not-found-content"},[_c('h1',[_vm._v("404")]),_c('h2',[_vm._v("Page or data not found")])])])
}]

export { render, staticRenderFns }